module.exports = __webpack_public_path__ + "static/media/coupon.3b1e3906.svg";